import { MainLayout } from '@root/components/layouts/Index';
import Header from '@root/components/Header';
import Footer from '@root/components/Footer';
import { Page } from '@root/pages/Type';
import withLayout from '@root/utils/withLayout';
import withCheckAuth from '@utils/withCheckAuth';
import TopSection from './TopSection';
import PricesSection from './PricesSection';
import FeaturesSection from './FeaturesSection';
import withTitle from '@root/utils/withTitle';

const Index: Page = () => {
    return (
        <>
            <Header />
            <TopSection />
            <FeaturesSection />
            <PricesSection />
            <Footer renderTopButton />
        </>
    );
};

export const getServerSideProps = withCheckAuth(async () => {
    return {
        props: {},
    };
});

export default withTitle(
    {
        translateKey: 'pageTitle',
        keywordsKey: 'pageKeywords',
        descriptionKey: 'pageDescription',
        default: 'Home page',
        namespace: 'landingServicesColocation',
        route: 'landing_services_colocation'
    },
    withLayout(MainLayout, Index),
);
